/*
 * Copyright 1999-2024 Jagex Ltd.
 */
export enum LoadingState {
  INITIAL = 'initial',
  PENDING = 'pending',
  STOPPED = 'stopped'
}

export interface LoadingItem {
  state: LoadingState;
}
